import React from 'react'
import { ButtonLogin, ContainerLogin, ContainerSignInGoogle, FormContainerLogin, FormInputLogin, ImgIconGoogle, ImgLogo, InputLogin, LineLogin, TextSignGoogle, TitleLogin, ContainerOr, TextP, ButtonRegister } from '../login/style'
import logo from "../../../../asset/logo/logogram_color.svg"

export const IdxResetPassword = () => {
  return (
    <ContainerLogin>

      <FormContainerLogin>
        <FormInputLogin>
          <ImgLogo src={logo} alt="Logo" />
        </FormInputLogin>
        <FormInputLogin>
          <TitleLogin>Reset Password</TitleLogin>
        </FormInputLogin>


        <FormInputLogin>
          <InputLogin type="email" placeholder="Email" />
        </FormInputLogin>

        <FormInputLogin>
          <InputLogin type="password" placeholder="Password" />
        </FormInputLogin>

        <FormInputLogin>
          <InputLogin type="password" placeholder="Confirmation password" />
        </FormInputLogin>

        <FormInputLogin>
          <ButtonLogin>
            Reset
          </ButtonLogin>
        </FormInputLogin>



      </FormContainerLogin>
    </ContainerLogin>
  )
}
